import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ea084eae = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _7ce18c57 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _c344dba4 = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _72cceec5 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _03e6ca30 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _77cdcd5e = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _9ca699b2 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _1a50140f = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _3ed85e16 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _46ecaf0c = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _622c12ca = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _ac391e1e = () => interopDefault(import('../../../pages/homeowner-dashboard/index.vue' /* webpackChunkName: "pages/homeowner-dashboard/index" */))
const _5e67a338 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _31944d8c = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _99394642 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _5f927951 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _f7d3cc28 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _3ddfcc8e = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _535f9de6 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _e2eded4c = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _7fab6de4 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _77d5f492 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _15c1e144 = () => interopDefault(import('../../../pages/photo-booking-confirmation/index.vue' /* webpackChunkName: "pages/photo-booking-confirmation/index" */))
const _31cf8904 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _41bedc4a = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _410a5f3e = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _36931128 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _5dfd0435 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _6ad1cef0 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _aefce844 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _1662d010 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _0dc47079 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _6421adb6 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _977cfe84 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _34d55968 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _04f54053 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _08da1280 = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _b4bd5e3a = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _336ede18 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _c8521324 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _62e11dab = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _02d35785 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _20cdbc5f = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _f3083c08 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _c77e04e4 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _4d040b64 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _9e6d2d20 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _8220e4a0 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _0e8c055b = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _59600560 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _7ca435c9 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _2413bae0 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _5295a4d6 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _14e1c25a = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _02ca6569 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _34f24e0a = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _3a5c811f = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _0ee27930 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _b8944970 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _4112b5a8 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _6c83c643 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _3a33ad9a = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _6f945de6 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _1d6192d4 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _0d17f2be = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _12ead288 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _8cd44020 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _0318baba = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _781af74e = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _dc88bcd2 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _ed5dc070 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _dbd29862 = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _36104996 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _44a1c986 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _6dd7c602 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _70a5b2ce = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _5b08368b = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _293e3c3c = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _a813af76 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _ea084eae,
    name: "404-error"
  }, {
    path: "/app",
    component: _7ce18c57,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _c344dba4,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _72cceec5,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _03e6ca30,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _77cdcd5e,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _9ca699b2,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _1a50140f,
    name: "comparables"
  }, {
    path: "/contact",
    component: _3ed85e16,
    name: "contact"
  }, {
    path: "/faq",
    component: _46ecaf0c,
    name: "faq"
  }, {
    path: "/favourites",
    component: _622c12ca,
    name: "favourites"
  }, {
    path: "/homeowner-dashboard",
    component: _ac391e1e,
    name: "homeowner-dashboard"
  }, {
    path: "/list-home",
    component: _5e67a338,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _31944d8c,
    name: "listing-management"
  }, {
    path: "/login",
    component: _99394642,
    name: "login"
  }, {
    path: "/market-data",
    component: _5f927951,
    name: "market-data"
  }, {
    path: "/messages",
    component: _f7d3cc28,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _3ddfcc8e,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _535f9de6,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _e2eded4c,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _7fab6de4,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _77d5f492,
    name: "offers"
  }, {
    path: "/photo-booking-confirmation",
    component: _15c1e144,
    name: "photo-booking-confirmation"
  }, {
    path: "/privacy",
    component: _31cf8904,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _41bedc4a,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _410a5f3e,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _36931128,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _5dfd0435,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _6ad1cef0,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _aefce844,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _1662d010,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _0dc47079,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _6421adb6,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _977cfe84,
    name: "users"
  }, {
    path: "/whoweare",
    component: _34d55968,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _04f54053,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _08da1280,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _b4bd5e3a,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _336ede18,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _c8521324,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _62e11dab,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _02d35785,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _20cdbc5f,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _f3083c08,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _c77e04e4,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _4d040b64,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _9e6d2d20,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _8220e4a0,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _0e8c055b,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _59600560,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _7ca435c9,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _2413bae0,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _5295a4d6,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _14e1c25a,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _02ca6569,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _34f24e0a,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _3a5c811f,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _0ee27930,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _b8944970,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _4112b5a8,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _6c83c643,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _3a33ad9a,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _6f945de6,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _1d6192d4,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _0d17f2be,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _12ead288,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _8cd44020,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _0318baba,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _781af74e,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _dc88bcd2,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _ed5dc070,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _dbd29862,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _36104996,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _44a1c986,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _6dd7c602,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _70a5b2ce,
    name: "listings-id-submit-success"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _5b08368b,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _293e3c3c,
    name: "users-id-section"
  }, {
    path: "/",
    component: _a813af76,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/user/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
